"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortOrientationSessions = sortOrientationSessions;
exports.describeOrientationScheduleChanges = describeOrientationScheduleChanges;
const field_changes_1 = require("./field-changes");
const bySessionStart = (a, b) => a.date.toMillis() - b.date.toMillis() || a.start.localeCompare(b.start);
function sortOrientationSessions(sessions) {
    return [...sessions].sort(bySessionStart);
}
function formatSchedule(sessions) {
    return sortOrientationSessions(sessions)
        .map((s) => `${(0, field_changes_1.formatShiftDate)(s.date)} ${(0, field_changes_1.formatShiftTimeRange)(undefined, s.start, s.end)}`)
        .join('; ');
}
function formatFlexibility(sessions) {
    return sessions.some((s) => s.negotiable)
        ? 'Dates and times flexible'
        : 'Fixed dates and times';
}
function describeOrientationScheduleChanges(before, after) {
    return (0, field_changes_1.presentChanges)([
        (0, field_changes_1.changedField)('Schedule', formatSchedule(before), formatSchedule(after)),
        (0, field_changes_1.changedField)('Flexibility', formatFlexibility(before), formatFlexibility(after)),
    ]);
}
//# sourceMappingURL=orientation-schedule-changes.js.map